<template>
  <div class="RouteContainer">
    <app-background :backgroundImg="'./static/images/' + sharedContent.backgroundImgBlur" />

    <div class="container">
      <div class="row Gallery">
        <div class="col-md-8 mx-auto pb-lg-5 d-block d-md-flex Gallery-container">

          <div class="Blurb">
            <h2 class="Blurb-title text-center">
              {{ galleryContent.title || 'Living with Wolves' }}
            </h2>
            <p class="Blurb-body">{{ galleryContent.description }}</p>
            <p class="Blurb-blockquote mt-3 text-center">Select a section to begin exploring the hidden life of wolves.</p>
          </div>

        </div>
      </div>

      <div class="row mt-3">
        <div 
          class="col-lg-3 col-md-5 mx-auto Map" 
          v-for="(section, i) in galleryContent.sections" 
          :key="i"
          :class="'Map--' + i"
        >
          <router-link :to="'/wolves-101/' + section.directory + '/'">
            <img
              class="Map-wrapper-img" 
              v-for="(previewImg, j) in section.previewImages" 
              :key="j"
              :class="['Map-wrapper-img--' + j, { 'zoom-out': selectedSection === i }]"
              :src="'./static/images/gallery/' + section.directory + '/' + previewImg.fileName">
          </router-link>
          <router-link :to="'/wolves-101/' + section.directory + '/'">
            <button class="Button Button--dark Map-button">
              <div class="row">
                <div class="col-9 col-lg-12">
                  {{ section.name }}
                </div>
                <div class="col-3 d-lg-none">
                  <span 
                    class="ButtonIcon ButtonIcon--small ButtonIcon--light Map-button-icon">
                    <icon name="arrow-right" scale=".85"></icon>
                  </span>
                </div>
              </div>
            </button>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import appBackground from './../partials/background'
import MixinHelper from './../mixins/helper'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/arrow-right'
export default {
  components: {
    appBackground,
    Icon
  },

  mixins: [ MixinHelper ],

  data () {
    return {
      selectedSection: null
    }
  },

  computed: {
    sharedContent () {
      return this.$store.getters.sharedContent
    },

    galleryContent () {
      return this.$store.getters.galleryContent
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'gallery')
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

@mixin Map-wrapper-img($posX, $posY) {
  transform: translate($posX, $posY);
}

.Gallery {
  height: auto;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    height: calc(100vh - 80px);
  }
}

.Gallery-container {
  flex-direction: column;
  justify-content: center;
  padding-top: 3rem;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    padding-top: 0;
  }
}

.Map {
  margin-bottom: 3em;
  position: relative;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    animation: fade-in 2s ease forwards;
    position: absolute;
  }
}

.Map--0 {
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    top: 14vh;
    left: 6vw;
  }
}

.Map--1 {
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    top: 16vh;
    right: 10vw;
  }
}

.Map--2 {
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    top: 63vh;
    left: 6vw;
  }
}

.Map--3 {
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    top: 73vh;
    left: 38vw;
  }
}

.Map--4 {
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    top: 62vh;
    left: 64vw;
  }
}

.Map-button {
  border-color: $transparentGray;
  font-size: 1em;
  padding: 1em 0 1em 1em;
  text-align: left;
  transform: translate(0);
  width: 100%;
  height: auto;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    padding: 0 2em;
    text-align: center;
    transform: translate(6vw, 1vh);
    width: auto;
    height: 3em;
  }
}

.Map-button-icon {
  margin: auto;
  @media screen and (max-width: $grid-xl) {
    display: flex;
  }
}

.Map-wrapper-img {
  background-color: $transparentGray;
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: inline-block;
  width: 50%;
  height: auto;
  max-width: 200px;
}

.Map-wrapper-img--0 {
  width: 100%;
  max-width: 100%;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    transform: translate(-1vw, 0);
    width: 33%;
  }
}

.Map-wrapper-img--1 {
  max-width: 50%;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    transform: translate(0, 2vh);
    width: 33%;
  }
}

.Map-wrapper-img--2 {
  max-width: 50%;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    transform: translate(-1vw, -1vh);
    width: 33%;
  }
}

.Map-wrapper-img--3 {
  display: none;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    display: inline-block;
    transform: translate(1vw, -1vh);
    width: 33%;
  }
}

.Map-wrapper-img--4 {
  display: none;
  @media screen and (min-width: $grid-xl) and (min-height: 900px) {
    display: inline-block;
    transform: translate(2vw, 1vh);
    width: 33%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routes/wolves-101.vue